// extracted by mini-css-extract-plugin
export default {"subtitle":"PlanCardTitle_subtitle__Nbvau","title":"PlanCardTitle_title__BHWvX"};